import { IRulesGiveaway } from '../../../interfaces';

class RulesGiveawayMapper {
    toPersistence(domainRulesGiveaway: IRulesGiveaway): any {
        return {
            allow_user_multiple_prizes: domainRulesGiveaway.allow_user_multiple_prizes,
            show_social_institution_name: domainRulesGiveaway.show_social_institution_name,
            show_winner_name: domainRulesGiveaway.show_winner_name,
            nfc_processing_delay_days: domainRulesGiveaway.nfc_processing_delay_days,
            nfe_processing_delay_days: domainRulesGiveaway.nfe_processing_delay_days,
            nfs_processing_delay_days: domainRulesGiveaway.nfs_processing_delay_days,
            raffle_delay_days: domainRulesGiveaway.raffle_delay_days,
        }
    }

    toDomain(persistenceRulesGiveaway: any): IRulesGiveaway {
        return {
            allow_user_multiple_prizes: persistenceRulesGiveaway.allow_user_multiple_prizes,
            show_social_institution_name: persistenceRulesGiveaway.show_social_institution_name,
            show_winner_name: persistenceRulesGiveaway.show_winner_name,
            nfc_processing_delay_days: persistenceRulesGiveaway.nfc_processing_delay_days,
            nfe_processing_delay_days: persistenceRulesGiveaway.nfe_processing_delay_days,
            nfs_processing_delay_days: persistenceRulesGiveaway.nfs_processing_delay_days,
            raffle_delay_days: persistenceRulesGiveaway.raffle_delay_days,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RulesGiveawayMapper();
